// VAVA Task Tracker · seed data
// 8 staff + tasks from TASK_TRACKER_v1.md §5 (SMART rewrites)

const STAFF = [
    { id: 'S01', name: 'Regina',   role: 'admin',    title: '老板',             stores: ['ALL'],         active: true,  password: 'vava2026' },
    { id: 'S02', name: 'Connie',   role: 'employee', title: '客服管理经理',     stores: ['ALL'],         active: true,  password: 'vava2026' },
    { id: 'S03', name: 'Yiva',     role: 'employee', title: '业务经理',         stores: ['ALL'],         active: true,  password: 'vava2026' },
    { id: 'S04', name: 'Melissa',  role: 'employee', title: 'NY 前台副经理',    stores: ['NY'],          active: true,  password: 'vava2026' },
    { id: 'S05', name: '泡泡',     role: 'employee', title: 'DT 业务经理',      stores: ['DT'],          active: true,  password: 'vava2026' },
    { id: 'S06', name: 'Jennifer', role: 'employee', title: 'NY 经理',          stores: ['NY'],          active: true,  password: 'vava2026' },
    { id: 'S07', name: 'Tiger',    role: 'employee', title: '晚班负责人',       stores: ['ALL'],         active: true,  password: 'vava2026' },
    { id: 'S08', name: 'Karen',    role: 'employee', title: 'RH 业务经理',      stores: ['RH'],          active: true,  password: 'vava2026' }
  ];

  const CATEGORIES = ['门店运营', '客服', '培训', '物料', '数据', '人员管理', '视频', '其他'];
  const STATUSES = ['待开始', '进行中', '阻塞', '已完成', '已取消'];
  const PRIORITIES = ['P0', 'P1', 'P2'];

  // Helpers
  const iso = (dateStr) => dateStr; // keep YYYY-MM-DD strings
  const now = '2026-05-11T10:30:00';
  // Helper for tasks that want explicit RACI ownership in the seed.
  // Tasks created without it fall through to storage.js's migration shim
  // which wraps single-assigneeId tasks as owners=[{R: assigneeId}].
  const withRaci = (task, owners) => ({ ...task, owners });

  const mk = (id, assignee, title, detail, category, priority, due, status, notes, blockReason, recurring, parentId, blockedBy) => ({
    id, title, detail, category,
    assigneeId: assignee, creatorId: 'S01',
    createdAt: '2026-04-15T09:00:00',
    startDate: null, dueDate: due,
    estHours: null, priority,
    status,
    blockReason: blockReason || '',
    updates: notes || [],
    adminNote: '',
    recurring: recurring || '一次性',
    parentId: parentId || null,
    blockedBy: blockedBy || [],
    completedAt: status === '已完成' ? '2026-04-18T15:00:00' : null
  });

  // ===== Connie · 7 tasks =====
  const CONNIE = [
    mk('T001', 'S02', '评估 3 店客服排班 · 提交优化方案',
      '本月内：评估当前 3 店客服覆盖排班 → 提交优化方案 PDF 给 Regina → 新排班 2026-05-15 前上线。',
      '客服', 'P1', '2026-05-15', '进行中',
      [
        { at: '2026-04-19T11:00:00', by: 'S02', text: '已完成 RH + NY 排班数据收集 · DT 待收集' },
        { at: '2026-04-21T14:30:00', by: 'S02', text: 'DT 数据已收集 · 本周出初稿' }
      ]),
    mk('T002', 'S02', '《客服 KPI 表 v1》',
      '2 周内：提交《客服 KPI 表 v1》· 覆盖引流 / 销售 / 好评 3 大指标 · 每人每周 + 每月目标值。',
      '客服', 'P0', '2026-05-05', '进行中',
      [{ at: '2026-04-20T10:00:00', by: 'S02', text: '已对标其他同行 KPI · 草稿本周完成' }]),
    mk('T003', 'S02', '客服晚班 SOP v1',
      '1 个月内：提交晚班 SOP v1 · 目标：晚班负责人每天填表时间 ≤ 10 分钟（当前 ≥ 20 分钟）。',
      '客服', 'P1', '2026-05-21', '待开始', []),
    mk('T004', 'S02', 'CSM 跟进 + 会员卡方案',
      '(a) 2 周内每周与 Samuel 同步 1 次 CSM 进展 (b) Q2 结束前提交"会员卡销售通过 CSM"方案。',
      '客服', 'P1', '2026-06-30', '阻塞',
      [{ at: '2026-04-18T16:00:00', by: 'S02', text: 'Samuel 本周出差 · 下周三同步' }],
      'Samuel 出差中 · 待返回'),
    mk('T005', 'S02', '客服团队双周例会',
      '周期性 · 每两周一次 · 每次会后提交会议纪要。',
      '客服', 'P2', '2026-05-03', '待开始', [], '', '每两周'),
    mk('T006', 'S02', '企业微信 vs 个人微信 迁移建议',
      '2 周内：评估企业微信 vs 个人微信差异 · 提交迁移建议 1 页。',
      '其他', 'P2', '2026-05-05', '待开始', []),
    mk('T007', 'S02', '3 主题配件清单（毕业季/婚礼/世界杯）',
      '本月内：确认 3 个主题各配件清单 + 预算 → 提交 Nina 执行采购。',
      '物料', 'P1', '2026-05-15', '进行中',
      [{ at: '2026-04-21T09:00:00', by: 'S02', text: '毕业季清单已定 · 婚礼 + 世界杯本周' }])
  ];

  // ===== Yiva · 4 tasks =====
  const YIVA = [
    withRaci(mk('T101', 'S03', '母亲节整理',
      '母亲节前 3 天完成：(a) 母亲节菜单上线 (b) 三店物料到位 (c) 员工话术培训 · 5 月 8 日截止。',
      '门店运营', 'P0', '2026-05-08', '进行中',
      [
        { at: '2026-04-19T15:00:00', by: 'S03', text: 'Connie 提供报价 · 和 Nina 对接物料中' },
        { at: '2026-04-21T10:20:00', by: 'S03', text: '菜单已定 · 3 店海报今天印 · 本周内完成培训' }
      ]), [
      { staffId: 'S03', role: 'R' }, // Yiva drives execution
      { staffId: 'S01', role: 'A' }, // Regina accountable for the holiday
      { staffId: 'S02', role: 'C' }, // Connie consulted on pricing
      { staffId: 'S08', role: 'C' }, // Karen consulted on RH rollout
      { staffId: 'S05', role: 'C' }, // 泡泡 consulted on DT rollout
      { staffId: 'S06', role: 'C' }, // Jennifer consulted on NY rollout
      { staffId: 'S04', role: 'I' }  // Melissa informed (front-of-house)
    ]),
    mk('T102', 'S03', '客服部新招 2 人（含 1 晚班）',
      '本月内新招 2 名客服（其中 1 名晚班）· 面试至少 5 人后定人。',
      '人员管理', 'P0', '2026-05-21', '进行中',
      [{ at: '2026-04-21T11:00:00', by: 'S03', text: '已面试 3 人 · 其中 1 人定为晚班候选' }]),
    mk('T103', 'S03', '跨部门双周例会',
      '周期性 · 每两周一次 · 与 Connie 同步。',
      '客服', 'P2', '2026-05-03', '待开始', [], '', '每两周'),
    mk('T104', 'S03', '晚班招聘（2 客服 + 1 后厨）',
      '6 月 1 日前：2 名晚班客服 + 1 名晚班后厨入职。',
      '人员管理', 'P1', '2026-06-01', '进行中',
      [{ at: '2026-04-20T09:00:00', by: 'S03', text: '和 Tiger 协同中 · 已发布 3 个渠道' }])
  ];

  // ===== Melissa · 7 tasks =====
  const MELISSA = [
    mk('T201', 'S04', '接手 NY 全员 + 运营周报',
      '5 月 1 日前完成 NY 全员工作交接 · 每周一提交 NY 运营周报给 Regina。',
      '门店运营', 'P0', '2026-05-01', '进行中',
      [{ at: '2026-04-21T13:00:00', by: 'S04', text: '交接完成 80% · 第一份周报本周一发出' }]),
    mk('T202', 'S04', 'NY 内部 + 跨部门例会',
      '周期性 · 内部每周 · 跨部门每月 2 次。',
      '门店运营', 'P2', '2026-04-28', '待开始', [], '', '每周'),
    withRaci(mk('T203', 'S04', '前台销售培训 Q&A 落地',
      '5 月 15 日前：(a) Q&A 文档由 Karen 和 Regina 定稿 (b) DT 培训落地 · 泡泡对接。',
      '培训', 'P0', '2026-05-15', '阻塞',
      [{ at: '2026-04-18T10:00:00', by: 'S04', text: '等 Karen Q&A 文档定稿' }],
      '等 Karen Q&A 文档'), [
      { staffId: 'S04', role: 'R' }, // Melissa drives the rollout
      { staffId: 'S08', role: 'R' }, // Karen co-owns the Q&A doc
      { staffId: 'S01', role: 'A' }, // Regina signs off final
      { staffId: 'S05', role: 'C' }  // 泡泡 consulted on DT delivery
    ]),
    mk('T204', 'S04', '客服流程跟岗 ≥ 8 小时',
      '2 周内：客服流程跟岗 ≥ 8 小时 · 提交客服流程图 · Connie 认可。',
      '客服', 'P1', '2026-05-05', '进行中',
      [{ at: '2026-04-20T14:00:00', by: 'S04', text: '已跟岗 4 小时 · 本周再 4 小时' }]),
    mk('T205', 'S04', 'CRM 客人添加（每周 5 个）',
      '每周至少将 5 个门店客人添加进客服微信系统 · 月底统计添加总数。',
      '客服', 'P1', '2026-05-31', '进行中',
      [{ at: '2026-04-21T16:00:00', by: 'S04', text: '本周已添加 5 人 · 继续' }], '', '每周'),
    mk('T206', 'S04', 'Catering menu 上线（待 Nina 调价）',
      '每周催 Nina 一次 · Nina 完成后 3 天内 catering menu 上线。',
      '门店运营', 'P1', '2026-05-10', '阻塞',
      [{ at: '2026-04-19T10:00:00', by: 'S04', text: '第 2 周催 Nina · Nina 说本周末出' }],
      '等 Nina 调价完成'),
    mk('T207', 'S04', 'Catering 全流程负责',
      '6 月 1 日前：独立负责 catering 询价 + 报价 + 订单全流程 · 每月 ≥ 10 个 catering 订单。',
      '门店运营', 'P1', '2026-06-01', '待开始', [])
  ];

  // ===== 泡泡 · 13 tasks =====
  const PAOPAO = [
    mk('T301', 'S05', 'DT 前台 4 主题培训',
      '5 月内完成 4 项培训 · 每项培训后员工考核通过：新品介绍 · Ins coupon · Google review · DT 配送。',
      '培训', 'P1', '2026-05-31', '进行中',
      [{ at: '2026-04-20T11:00:00', by: 'S05', text: '新品介绍已培训 · 本周 Ins coupon' }]),
    mk('T302', 'S05', 'DT 试吃培训',
      '[部分阻塞] NY 敲定后 1 周内 DT 落地。',
      '培训', 'P2', '2026-05-15', '阻塞', [], '等 NY 敲定 (T203 Q&A 文档)', '一次性', null, ['T203']),
    mk('T303', 'S05', 'DT 报价培训',
      '[部分阻塞] 敲定后 1 周内 DT 落地。',
      '培训', 'P2', '2026-05-15', '阻塞', [], '等 Connie/Karen 敲定 (T203 Q&A 文档)', '一次性', null, ['T203']),
    mk('T304', 'S05', 'DT 月度员工会',
      '周期性 · 每月 1 次 · 每次 ≤ 1 小时 · 提交纪要。',
      '人员管理', 'P2', '2026-05-15', '待开始', [], '', '每月'),
    mk('T305', 'S05', '会员卡偏好调研（20 客户）',
      '本月内：调研 20 个眼熟客户会员卡偏好 · 提交偏好分布报告。',
      '数据', 'P2', '2026-05-21', '进行中',
      [{ at: '2026-04-21T15:00:00', by: 'S05', text: '已访谈 8 人' }]),
    mk('T306', 'S05', 'DT 每日新品咨询统计',
      '每天记录 · 发至每日汇总群。',
      '数据', 'P2', '2026-04-30', '进行中', [], '', '每日'),
    mk('T307', 'S05', '客人询问店内无货产品',
      '每次开会汇报 · 系统里记录。',
      '数据', 'P2', '2026-05-15', '进行中', [], '', '每周'),
    mk('T308', 'S05', 'DT 现货销售周趋势',
      '每周一提交上周 DT 销售趋势表。',
      '数据', 'P2', '2026-04-28', '进行中', [], '', '每周'),
    mk('T309', 'S05', 'DT 设计切面图 × 5',
      '本月内：完成 5 款设计切面图 · 前后对比。',
      '物料', 'P2', '2026-05-21', '待开始', []),
    mk('T310', 'S05', 'DT 配送 Flyer 设计印刷',
      '与 mkt 对接后 2 周内：完成 DT 配送 Flyer 设计 + 印刷 + 上架。',
      '物料', 'P2', '2026-05-15', '待开始', []),
    mk('T311', 'S05', 'DT 设计款照片归档（≥ 30 款）',
      '1 周内：≥ 30 款设计款照片上传 Google Drive 共享。',
      '物料', 'P2', '2026-04-28', '进行中',
      [{ at: '2026-04-21T17:00:00', by: 'S05', text: '已上传 18 款' }]),
    mk('T312', 'S05', 'DT 月度视频 × 2',
      '每月 2 段视频（工作日 vlog / 一日店长等）· 交付给 mkt 剪辑。',
      '视频', 'P2', '2026-04-30', '待开始', [], '', '每月'),
    mk('T313', 'S05', 'DT 客户群运营',
      '建立 DT 客户群 · 每周 ≥ 3 条内容 · 拉新 10 人触发优惠券。',
      '客服', 'P2', '2026-05-31', '进行中', [], '', '每周')
  ];

  // ===== Jennifer · 4 tasks =====
  const JENNIFER = [
    mk('T401', 'S06', '口味偏好量化表 v1',
      '2 周内：设计口味偏好量化表 v1 · 提交 Regina 审核。',
      '数据', 'P1', '2026-05-05', '进行中',
      [{ at: '2026-04-20T10:00:00', by: 'S06', text: '表结构设计完成' }]),
    mk('T402', 'S06', 'NY 店内物料更新（flyer + table stand）',
      '本月内：NY 店内物料全套更新。',
      '物料', 'P2', '2026-05-21', '待开始', []),
    mk('T403', 'S06', '配合后厨上新 tasting 小杯',
      '[条件待办] 后厨确认后 1 周内：物料清单 + SOP + 前台培训。',
      '门店运营', 'P2', '2026-05-15', '阻塞', [], '等后厨确认'),
    mk('T404', 'S06', '与 Melissa / Tiger 周同步',
      '周期性 · 每周与 Melissa 同步 1 次 · 与 Tiger 后厨事项随时对接。',
      '门店运营', 'P2', '2026-04-28', '待开始', [], '', '每周')
  ];

  // ===== Tiger · 3 tasks =====
  const TIGER = [
    mk('T501', 'S07', '晚班招聘 2 人',
      '6 月 1 日前：2 名晚班员工入职 · 至少面试 5 人（和 Yiva 协同）。',
      '人员管理', 'P0', '2026-06-01', '进行中',
      [{ at: '2026-04-21T19:00:00', by: 'S07', text: '已面试 2 人 · 本周继续' }]),
    mk('T502', 'S07', '员工诉求月度会',
      '每月与 Jennifer / Melissa 各开 1 次员工诉求沟通会 · 提交诉求汇总给 Regina。',
      '人员管理', 'P2', '2026-05-15', '待开始', [], '', '每月'),
    mk('T503', 'S07', '月度短视频 × 4',
      '每月完成 4 段短视频 (30-60 秒 / 段) · 交付 Nina 剪辑。',
      '视频', 'P2', '2026-04-30', '进行中',
      [{ at: '2026-04-18T20:00:00', by: 'S07', text: '已完成 2 段' }], '', '每月')
  ];

  // ===== Karen · 14 tasks (3 done) =====
  const KAREN = [
    mk('T601', 'S08', 'RH 灯牌采购',
      '本周内：确认 RH 灯牌供应商 + 款式 + 报价 · 提交 Regina 审批。',
      '物料', 'P1', '2026-04-28', '进行中',
      [{ at: '2026-04-21T14:00:00', by: 'S08', text: '3 家供应商报价对比中' }]),
    mk('T602', 'S08', 'RH 官网款拍摄 × 10',
      '本月内：完成 10 款官网款拍摄 · 上传指定 Google Drive。',
      '物料', 'P1', '2026-05-21', '进行中',
      [{ at: '2026-04-20T13:00:00', by: 'S08', text: '已完成 4 款' }]),
    mk('T603', 'S08', 'RH party size 礼物盒',
      '补充 RH 门店 party size 礼物盒。',
      '物料', 'P2', '2026-04-10', '已完成',
      [{ at: '2026-04-08T16:00:00', by: 'S08', text: '已到货 · 已上架' }]),
    mk('T604', 'S08', '主题配件（毕业季/婚礼/世界杯）',
      '建议考虑增加毕业季、婚礼、世界杯主题配件。',
      '物料', 'P2', '2026-04-12', '已完成',
      [{ at: '2026-04-10T10:00:00', by: 'S08', text: '方案已提交 Connie' }]),
    mk('T605', 'S08', 'RH 口味切面照打印',
      '增加 RH 门店物料，设计类口味切面照打印。',
      '物料', 'P2', '2026-04-15', '已完成',
      [{ at: '2026-04-14T11:00:00', by: 'S08', text: '已打印 · 已上架' }]),
    mk('T606', 'S08', 'RH 官网下单 post card',
      '本月内：post card 设计 + 印刷 + 上架。',
      '物料', 'P2', '2026-05-21', '待开始', []),
    mk('T607', 'S08', 'RH 门店视频拍摄',
      'Regina / Cherry 确认后 2 周内：门店视频拍摄完成。',
      '视频', 'P2', '2026-05-10', '阻塞', [], '等 Regina/Cherry 确认'),
    mk('T608', 'S08', 'Q&A 文档 ✅',
      '前台销售培训 Q&A。',
      '培训', 'P1', '2026-04-15', '已完成',
      [{ at: '2026-04-14T16:00:00', by: 'S08', text: 'Q&A v1 完成 · 提交 Regina' }]),
    mk('T609', 'S08', '《客诉 SOP》v1',
      '2 周内：《客诉 SOP》v1 · 覆盖 5 种常见场景 · 培训前台。',
      '培训', 'P1', '2026-05-05', '进行中',
      [{ at: '2026-04-21T15:30:00', by: 'S08', text: '已收集 3 种场景' }]),
    mk('T610', 'S08', '《突发 SOP》v1',
      '2 周内：《突发 SOP》v1 · 覆盖 5 种场景 · 培训。',
      '培训', 'P1', '2026-05-05', '待开始', []),
    mk('T611', 'S08', '蛋糕 up sale 物料 + 话术',
      '本月内：与 Nina 对接采购 3 款物料 + 落地 up sale 话术。',
      '物料', 'P2', '2026-05-21', '待开始', []),
    mk('T612', 'S08', '门店 4 平台发光二维码',
      '本月内：微信 / WhatsApp / 小红书 / Ins 发光二维码到位。',
      '物料', 'P2', '2026-05-21', '进行中',
      [{ at: '2026-04-20T11:00:00', by: 'S08', text: '二维码已生成 · 灯箱定制中' }]),
    mk('T613', 'S08', 'RH 新品咨询 vs 购买记录',
      '每天记录 · 周一提交上周数据。',
      '数据', 'P1', '2026-04-28', '进行中', [], '', '每日'),
    mk('T614', 'S08', 'RH 每日口味汇总',
      '每天记录 · 每周一统计提交。',
      '数据', 'P1', '2026-04-28', '进行中', [], '', '每日')
  ];

  // ===== 跨职能项目（parent tasks with subtasks）=====
  // These are initiative-level tasks owned by one person but broken down
  // across multiple owners. Regina uses these to see a full breakdown in
  // her /admin 项目视图.
  const PROJECTS = [
    // Project 1: Mother's Day initiative
    withRaci(mk('T901', 'S03', '【项目】母亲节大促 3 店联动',
      '母亲节是 VAVA 全年第二大销售节点。目标：三店联动、话术统一、物料齐备、菜单抢先上线。\n\n子项拆分见下方 7 条。Yiva 为项目总负责人，每周同步进度。',
      '门店运营', 'P0', '2026-05-08', '进行中',
      [{ at: '2026-04-20T09:00:00', by: 'S03', text: '项目启动 · 7 个子项已派发给对应负责人' },
       { at: '2026-04-21T10:20:00', by: 'S03', text: '菜单已定 · RH 海报先行 · NY/DT 本周跟进' }]), [
      { staffId: 'S03', role: 'R' }, // Yiva drives 3-store project
      { staffId: 'S01', role: 'A' }, // Regina accountable for holiday outcome
      { staffId: 'S08', role: 'R' }, // Karen co-R for RH execution
      { staffId: 'S05', role: 'R' }, // 泡泡 co-R for DT execution
      { staffId: 'S06', role: 'R' }, // Jennifer co-R for NY execution
      { staffId: 'S02', role: 'C' }, // Connie consulted on CS messaging
      { staffId: 'S04', role: 'I' }  // Melissa informed (NY front)
    ]),
    mk('T902', 'S02', '母亲节限定菜单上线 + 报价',
      '由 Connie 与 Nina 对接，完成 3 店母亲节限定菜单 + 报价结构（含 catering 单独报价），最终版提交 Yiva。',
      '客服', 'P0', '2026-05-03', '进行中',
      [{ at: '2026-04-21T11:00:00', by: 'S02', text: '菜单已定 · 报价与 Nina 对接中' }],
      '', '一次性', 'T901'),
    mk('T903', 'S08', 'RH 母亲节物料到位',
      'RH 店所需物料：店内海报 × 3 · 包装丝带 · 礼盒心意卡。Karen 联系 Nina 采购并到店上架。',
      '物料', 'P0', '2026-05-06', '进行中',
      [{ at: '2026-04-21T14:30:00', by: 'S08', text: '海报设计已定稿 · 今日印刷' }],
      '', '一次性', 'T901'),
    mk('T904', 'S04', 'NY 母亲节物料到位',
      'NY 店所需物料：店内海报 × 3 · 包装丝带 · 礼盒心意卡。Melissa 接收 RH 同款物料、铺店。',
      '物料', 'P0', '2026-05-06', '待开始', [], '', '一次性', 'T901'),
    mk('T905', 'S05', 'DT 母亲节物料到位',
      'DT 店所需物料：店内海报 × 2 · 发光二维码 · 包装丝带。泡泡接收物料并铺店。',
      '物料', 'P0', '2026-05-06', '待开始', [], '', '一次性', 'T901'),
    mk('T906', 'S08', 'RH 前台母亲节话术培训',
      '向 RH 前台讲解母亲节限定菜单 · 报价 · up sale 话术 · 客诉应对。Karen 主讲，考核当场通过。',
      '培训', 'P1', '2026-05-07', '待开始', [], '', '一次性', 'T901'),
    mk('T907', 'S04', 'NY 前台母亲节话术培训',
      '向 NY 前台讲解母亲节限定菜单 · 报价 · up sale 话术 · 客诉应对。Melissa 主讲，考核当场通过。',
      '培训', 'P1', '2026-05-07', '待开始', [], '', '一次性', 'T901'),
    mk('T908', 'S05', 'DT 前台母亲节话术培训',
      '向 DT 前台讲解母亲节限定菜单 · 报价 · 外卖配送话术。泡泡主讲。',
      '培训', 'P1', '2026-05-07', '待开始', [], '', '一次性', 'T901'),

    // Project 2: Night shift team build
    mk('T911', 'S03', '【项目】晚班团队搭建',
      '当前晚班仅 1 人负责，支撑不住单量。目标：6 月 1 日前晚班客服 × 2 + 晚班后厨 × 1 全部入职 + SOP 落地 + 培训完成。\n\nYiva 为总协调，Tiger 负责面试执行。',
      '人员管理', 'P0', '2026-06-01', '进行中',
      [{ at: '2026-04-20T09:00:00', by: 'S03', text: '项目启动 · 拆分为 4 个子项' }]),
    mk('T912', 'S07', '晚班员工招聘（2 客服 + 1 后厨）',
      '6 月 1 日前：2 名晚班客服 + 1 名晚班后厨入职。至少面试 5 人后定人。',
      '人员管理', 'P0', '2026-05-28', '进行中',
      [{ at: '2026-04-21T19:00:00', by: 'S07', text: '已面试 3 人 · 本周继续' }],
      '', '一次性', 'T911'),
    mk('T913', 'S02', '晚班 SOP v1',
      '1 个月内：提交晚班 SOP v1 · 目标：晚班负责人每天填表时间 ≤ 10 分钟（当前 ≥ 20 分钟）。',
      '客服', 'P1', '2026-05-21', '待开始', [], '', '一次性', 'T911'),
    mk('T914', 'S05', '晚班新员工岗前培训',
      'SOP 落地后 1 周内：向新入职晚班员工完成岗前培训 · 考核通过上岗。',
      '培训', 'P1', '2026-06-05', '阻塞', [],
      '等晚班员工入职 + SOP 定稿', '一次性', 'T911'),

    // Project 3: Q2 training system
    mk('T921', 'S01', '【项目】Q2 培训体系建立',
      '目标：建立标准化培训体系，覆盖前台销售 · 客诉处理 · 突发情况。Q2 结束前 3 店全员培训通过。\n\nRegina 顶层推动，Karen 主导 RH 试点。',
      '培训', 'P1', '2026-06-30', '进行中',
      [{ at: '2026-04-20T14:00:00', by: 'S01', text: 'Karen Q&A 文档已交付 · 准备 3 店落地' }]),
    mk('T922', 'S08', 'RH 客诉 SOP v1 + 培训',
      '2 周内：《客诉 SOP》v1 · 覆盖 5 种常见场景 · RH 前台培训完成。',
      '培训', 'P1', '2026-05-05', '进行中',
      [{ at: '2026-04-21T15:30:00', by: 'S08', text: '已收集 3 种场景 · 本周出初稿' }],
      '', '一次性', 'T921'),
    mk('T923', 'S08', 'RH 突发情况 SOP v1 + 培训',
      '2 周内：《突发 SOP》v1 · 覆盖 5 种场景（设备 / 食材 / 投诉等）· RH 前台培训完成。',
      '培训', 'P1', '2026-05-05', '待开始', [], '', '一次性', 'T921'),
    mk('T924', 'S04', 'NY 培训体系落地',
      'Karen SOP 成稿后：NY 前台跟 Karen SOP 培训 + 考核。Melissa 对接。',
      '培训', 'P1', '2026-05-15', '阻塞', [],
      '等 Karen SOP v1', '一次性', 'T921'),
    mk('T925', 'S05', 'DT 培训体系落地',
      'Karen SOP 成稿后：DT 前台跟 Karen SOP 培训 + 考核。泡泡对接。',
      '培训', 'P1', '2026-05-15', '阻塞', [],
      '等 Karen SOP v1', '一次性', 'T921')
  ];

  const ALL_TASKS = [...CONNIE, ...YIVA, ...MELISSA, ...PAOPAO, ...JENNIFER, ...TIGER, ...KAREN, ...PROJECTS];

export const VAVA_SEED = {
  STAFF,
  CATEGORIES,
  STATUSES,
  PRIORITIES,
  TASKS: ALL_TASKS,
  NOW: now
};
